import ApiItemsCollection from '../interfaces/ApiItemsCollection';

export const mapApiItemsCollectionToClientItemsCollection = <ApiT, ClientT>(
  apiCollection: ApiItemsCollection<ApiT>,
  mapFunction: (data: ApiT[]) => ClientT[]
) => {
  const { data, nextCursor, total } = apiCollection;
  return { items: mapFunction(data), nextCursor, totalItems: total };
};
